var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rentabilidade-component" },
    [
      _c("div", { staticClass: "descricoes" }),
      _c("v-card", { staticClass: "grafico-wrapper", attrs: { flat: "" } }, [
        _c("div", { staticClass: "grafico-desempenho" }, [
          _c("div", { staticClass: "top-grafico" }, [
            _c("div", { staticClass: "top" }, [
              _c("div", { staticClass: "title-grafico" }, [
                _c("span", [_vm._v("Resultado Financeiro")])
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "grafico" },
            [
              _c("BarAndLine", {
                attrs: {
                  chartData: _vm.testeObj,
                  chartDataCDI: _vm.arrCDI,
                  options: _vm.options,
                  plugins: _vm.plugins
                }
              })
            ],
            1
          ),
          _vm.arrPrincipal.length
            ? _c("div", { staticClass: "media-doze-meses" }, [
                _c("span", [
                  _vm._v(
                    "A média dos 12 meses foi de: " +
                      _vm._s(_vm.mediaDozeMesesFormatada)
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }